import React from 'react';
import { Link } from 'react-router-dom';
import WorkflowBuilderWizard from '../components/wizards/WorkflowBuilderWizard';
import { PageHeader } from '../components/ui';
import { Icon } from '../components/icons';

const CreateWorkflowPage: React.FC = () => (
  <div className="page-container">
    <PageHeader
      eyebrow={<Link to="/workflows"><Icon name="arrow-left" size={12} /> Meine Workflows</Link>}
      title="Workflow anlegen"
      subtitle="Name und Beschreibung, dann die Schritte mit Prompt und Anbieter. Fertige Abläufe gibt es unter „Vorlagen laden“."
    />
    <WorkflowBuilderWizard />
  </div>
);

export default CreateWorkflowPage;
